<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="Voucher list" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
        <mt-button slot="right" @click="$router.push({name:'SellerVoucherForm',query:{mode:'add'}})">Add</mt-button>
      </mt-header>
    </div>
    <div v-if="!seller.is_platform_store" class="notice">
      <span>Package expiration time:<span v-if="current_quota" class="red">{{$moment.unix(current_quota.voucherquota_endtime).format('YYYY.MM.DD')}}</span><span class="red" v-else>You have not bought the package yet</span></span>
      <mt-button class="btn" @click="addQuota(current_quota)" size="small" type="primary"><span v-if="current_quota">Renewal</span><span v-else>Buy</span></mt-button>
    </div>
    <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
    <div
      class="list-wrapper"
      v-if="voucher_list && voucher_list.length"
    >
      <div @click="goVoucerEdit(item)" class="common-voucher common-voucher02" :class="(item.vouchertemplate_state != 1)?'disable':''" v-for="(item,index) in voucher_list" :key="item.vouchertemplate_id">
        <div class="par"><p>Order over {{item.vouchertemplate_limit}} dollar</p><sub class="sign">$</sub><span>{{item.vouchertemplate_price}}</span></div>
        <div class="copy">Valid until <p>{{$moment.unix(item.vouchertemplate_enddate).format('YYYY.MM.DD')}}<br></p></div>
        <i></i>
      </div>

    </div>
    <empty-record v-else-if="voucher_list && !voucher_list.length"></empty-record>
  </div>
  </div>
</template>

<script>
import { getVoucherList, addQuota } from '../../../api/sellerVoucher'
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'BalanceHistory',
  components: {
    EmptyRecord
  },
  data () {
    return {
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      wrapperHeight: 0,

      voucher_list: false,
      current_quota: false,
      voucher_storetimes_limit: false,
      promotion_voucher_price: false
    }
  },
  created () {

  },

  mounted () {
    this.wrapperHeight = document.documentElement.clientHeight - 90
  },
  computed: {
    ...mapState({
      seller: state => state.seller.info
    })

  },
  methods: {
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getVoucherList(true)
      }
    },
    goVoucerEdit (item) {
      if (item.vouchertemplate_state == 1 && !item.vouchertemplate_giveout) {
        this.$router.push({ name: 'SellerVoucherForm', query: { mode: 'edit', tid: item.vouchertemplate_id } })
      } else {
        Toast('The current voucher cannot be edited')
      }
    },
    addQuota (type) {
      MessageBox.prompt('The unit of purchase is month (30 days),Up to 12 months at a time,You need to pay ' + this.promotion_voucher_price + ' dollar per month,Relevant expenses will be deducted from the account period settlement of the store,A maximum of ' + this.voucher_storetimes_limit + ' events are posted per month', (type ? 'Renewal' : 'Buy') + ' package', { inputType: 'number' }).then(({ value, action }) => {
        addQuota(value).then(res => {
          Toast(res.message)
          this.current_quota = { voucherquota_endtime: res.result.voucherquota_endtime }
        }).catch(function (error) {
          Toast(error.message)
        })
      })
    },
    getVoucherList () {
      Indicator.open()

      getVoucherList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
        this.current_quota = res.result.current_quota
        this.promotion_voucher_price = res.result.promotion_voucher_price
        this.voucher_storetimes_limit = res.result.voucher_storetimes_limit
        let temp = res.result.vouchertemplate_list
        if (temp) {
          if (!this.voucher_list) {
            this.voucher_list = temp
          } else {
            this.voucher_list = this.voucher_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;

}
.common-voucher{margin:0.5rem auto}
  .notice{font-size:.7rem;padding:.5rem;background:#FCF8E3;color:#C09853;line-height: 1.65rem;
    .red{color:#F00}
    .btn{float:right}
  }
</style>
